/**
 * @generated SignedSource<<18c35fdc5f9cf6d9149b995e734d7f35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RefundAvailabilityAlarmButtonMutation$variables = {
  refundId: string;
};
export type RefundAvailabilityAlarmButtonMutation$data = {
  readonly applyRefundPossibleAlarm: {
    readonly result: boolean;
  };
};
export type RefundAvailabilityAlarmButtonMutation = {
  response: RefundAvailabilityAlarmButtonMutation$data;
  variables: RefundAvailabilityAlarmButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundId",
        "variableName": "refundId"
      }
    ],
    "concreteType": "ApplyRefundPossibleAlarmOutput",
    "kind": "LinkedField",
    "name": "applyRefundPossibleAlarm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RefundAvailabilityAlarmButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RefundAvailabilityAlarmButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ff5f29de6af8c7f25bbc9e80be0e5524",
    "id": null,
    "metadata": {},
    "name": "RefundAvailabilityAlarmButtonMutation",
    "operationKind": "mutation",
    "text": "mutation RefundAvailabilityAlarmButtonMutation(\n  $refundId: String!\n) {\n  applyRefundPossibleAlarm(refundId: $refundId) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "062375f9b92147b2555dba5eafe5574a";

export default node;
